<script setup lang="ts">
import { ref, PropType } from 'vue';

const props = defineProps({
  options: {
    type: Array as PropType<{ label: string; value: string }[]>,
    default: () => [],
  },
  dense: {
    type: Boolean,
    default: () => false,
  },
});

const emit = defineEmits(['filter']);

const filter = ref<string>('');
const filterTitle = ref<string>('');

let to: ReturnType<typeof setTimeout>;
function updateFilter() {
  if (to) {
    clearTimeout(to);
  }
  to = setTimeout(() => {
    emit('filter', { filter: filter.value, filterTitle: filterTitle.value });
  }, 400);
}

function filterByType(type: string) {
  filter.value = filter.value === type ? '' : type;
  updateFilter();
}
</script>

<template>
  <v-card elevation="2" class="filters">
    <ul class="filter-items">
      <li class="filter"><label>Filter by:</label></li>
      <li class="filter" v-if="props.options.length">
        <v-btn
          flat
          density="compact"
          :color="filter === '' ? 'primary' : ''"
          @click="filterByType('')"
          :class="{ small: dense }"
          >All</v-btn
        >
      </li>
      <li
        class="filter-item"
        v-for="option in props.options"
        :key="option.label"
      >
        <v-btn
          density="compact"
          flat
          :color="filter === option.value ? 'primary' : ''"
          @click="filterByType(option.value)"
          :class="{ small: dense }"
          >{{ option.label }}</v-btn
        >
      </li>

      <li class="filter-item filter-title">
        <v-text-field
          v-model="filterTitle"
          density="compact"
          color="primary"
          label="Filter"
          variant="underlined"
          append-icon="mdi-magnify"
          hide-details
          @keyup="updateFilter"
        >
        </v-text-field>
      </li>
      <slot />
    </ul>
  </v-card>
</template>
<style>
.filters {
  display: flex;
  align-items: center;
  padding: 8px 8px 16px 8px;
  margin-bottom: 16px;
}

.filter-items {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
}

.filter label {
  font-weight: bold;
  padding: 8px;
  position: relative;
  top: 8px;
}
.filter .v-btn,
.filter-item .v-btn {
  position: relative;
  top: 8px;
}

.filter-item {
  padding: 0 8px;
}

.filter-title {
  width: 280px;
}

.small .v-btn__content {
  font-size: 9px;
}
</style>
